<div class="image-zoom-viewer">
  <div class="viewer-toolbar">
    <div class="viewer-info mat-body-1 mb-0">
      <span class="viewer-image-name" [title]="currentImage?.name">{{ currentImage?.name }}</span>
      @if (naturalWidth) {
        <span class="viewer-image-meta">{{ naturalWidth }} × {{ naturalHeight }} px</span>
      }
      @if (fileSizeBytes) {
        <span class="viewer-image-meta">{{ fileSizeBytes | bitfBytes }}</span>
      }
      @if (hasMultipleImages) {
        <span class="viewer-image-counter">{{ currentIndex + 1 }} / {{ images.length }}</span>
      }
    </div>
    <div class="viewer-actions">
      <button
        mat-icon-button
        [disabled]="scale <= minScale"
        [matTooltip]="'ITEM.DETAIL.ZOOM_OUT' | translate"
        (click)="onZoomOut()"
      >
        <mat-icon>zoom_out</mat-icon>
      </button>
      <button
        mat-icon-button
        [disabled]="scale >= maxScale"
        [matTooltip]="'ITEM.DETAIL.ZOOM_IN' | translate"
        (click)="onZoomIn()"
      >
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button mat-icon-button [matTooltip]="'ITEM.DETAIL.ZOOM_RESET' | translate" (click)="onReset()">
        <mat-icon>center_focus_weak</mat-icon>
      </button>
    </div>
    <button mat-icon-button aria-label="Close" class="viewer-close" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div
    #viewport
    class="viewer-viewport"
    [class.panning]="isPanning"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerCancel($event)"
  >
    @if (loading) {
      <mat-spinner class="viewer-spinner" [diameter]="48"></mat-spinner>
    }
    <img
      #imageElement
      class="viewer-image"
      [class.loading]="loading"
      [src]="imageUrl"
      [alt]="currentImage?.name"
      [style.width.px]="fitWidth"
      [style.height.px]="fitHeight"
      [style.transform]="getTransform()"
      draggable="false"
      (load)="onImageLoad()"
      (error)="onImageError()"
    />

    @if (hasMultipleImages) {
      <button
        mat-icon-button
        class="viewer-nav viewer-nav-previous"
        [disabled]="currentIndex === 0"
        [matTooltip]="'ITEM.DETAIL.IMAGE_PREVIOUS' | translate"
        (click)="onPreviousImage()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        mat-icon-button
        class="viewer-nav viewer-nav-next"
        [disabled]="currentIndex === images.length - 1"
        [matTooltip]="'ITEM.DETAIL.IMAGE_NEXT' | translate"
        (click)="onNextImage()"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    }
  </div>
</div>
